import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation, use_slice_grid2d } from '@/hooks/store/use_slices';
import { REMOTE__grid2d_get_generation } from '@/state/grid2d/grid2d_for_entity/REMOTE__grid2d_get_generation';
import { is_grid2d_loading } from '@/utils/utils_grid2d';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';

export function WATCHER_GRID2D__get__generation_current() {
  /*
   * STORE
   */
  const dispatch = use_dispatch();

  const { generation_current } = use_slice_generation(['generation_current']);
  const { grids2d_map } = use_slice_grid2d(['grids2d_map']);
  /*
   * METHODS
   */
  use_effect(() => {
    if (generation_current.is_stub()) return;
    if (grids2d_map.has(generation_current._id)) return; //already loaded
    if (is_grid2d_loading(ENUM__workspace_entity.ENTITY_GENERATION, generation_current._id)) return; //already loading

    void dispatch(REMOTE__grid2d_get_generation([generation_current._id]));
  }, [generation_current]);

  /*
   * HTML
   */
  return <></>;
}
